module.exports = __webpack_public_path__ + "img/R2-ma3adee.e0d50c21.jpeg";